// extracted by mini-css-extract-plugin
export var grid = "_1g-0";
export var span1 = "_1g-2";
export var span10 = "_1g-b";
export var span10L = "_1g-z";
export var span10M = "_1g-n";
export var span10Xl = "_1g-1b";
export var span11 = "_1g-c";
export var span11L = "_1g-10";
export var span11M = "_1g-o";
export var span11Xl = "_1g-1c";
export var span12 = "_1g-d";
export var span12L = "_1g-11";
export var span12M = "_1g-p";
export var span12Xl = "_1g-1d";
export var span1L = "_1g-q";
export var span1M = "_1g-e";
export var span1Xl = "_1g-12";
export var span2 = "_1g-3";
export var span2L = "_1g-r";
export var span2M = "_1g-f";
export var span2Xl = "_1g-13";
export var span3 = "_1g-4";
export var span3L = "_1g-s";
export var span3M = "_1g-g";
export var span3Xl = "_1g-14";
export var span4 = "_1g-5";
export var span4L = "_1g-t";
export var span4M = "_1g-h";
export var span4Xl = "_1g-15";
export var span5 = "_1g-6";
export var span5L = "_1g-u";
export var span5M = "_1g-i";
export var span5Xl = "_1g-16";
export var span6 = "_1g-7";
export var span6L = "_1g-v";
export var span6M = "_1g-j";
export var span6Xl = "_1g-17";
export var span7 = "_1g-8";
export var span7L = "_1g-w";
export var span7M = "_1g-k";
export var span7Xl = "_1g-18";
export var span8 = "_1g-9";
export var span8L = "_1g-x";
export var span8M = "_1g-l";
export var span8Xl = "_1g-19";
export var span9 = "_1g-a";
export var span9L = "_1g-y";
export var span9M = "_1g-m";
export var span9Xl = "_1g-1a";
export var stretch = "_1g-1";